export const BaitStates = {
    IDLE: Symbol('idle'),
    EATEN: Symbol('eaten'),
    EMPTY: Symbol('empty')
};
